/**
 * Router de Fermin Marker (TanStack Router, rutas file-based en src/routes/).
 * No añadas rutas aquí: crea el archivo en src/routes/ y el plugin regenera routeTree.gen.ts.
 *
 * Sin `scrollRestoration`: el kiosco no tiene historial navegable ni scroll (research R-3).
 */
import { createRouter } from '@tanstack/react-router';

import { routeTree } from './routeTree.gen';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
